if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var ownValues = Object.values(obj);
    var i = ownProps.length;
    var resArray = new Array(i); // preallocate the Array
    while (i--) { resArray[i] = [ownProps[i], ownValues[i]]; }

    return resArray;
  };
}
